import VideoModel from '../Apis/Video.js'
import Controller from './Controller.js';

export default class VideoController extends Controller {

    constructor(videoGalleryId) {
        super(new VideoModel(videoGalleryId))
    }


}